// config/agents.ts

export interface AgentDefinition {
    value: string
    agentType: string
    description: string
    label: string
}

export const AGENTS: Record<string, AgentDefinition> = {
    SCREENING_ASSESSMENT_AGENT_VOICE: {
        value: "SCREENING_ASSESSMENT_AGENT_VOICE",
        agentType: "AI Screening Agent",
        description: "Conducts voice-based screening calls to evaluate candidate",
        label: "Screening",
    },

    SCREENING_AGENT_AUDIO: {
        value: "SCREENING_AGENT_AUDIO",
        agentType: "Audio Screening Agent",
        description: "Voice-based screening format",
        label: "Audio Screening",
    },

    SCREENING_AGENT_VIDEO: {
        value: "SCREENING_AGENT_VIDEO",
        agentType: "Video Screening Agent",
        description: "Face-to-face video screening format",
        label: "Video Screening",
    },

    INTERVIEW_SCHEDULER_AGENT: {
        value: "INTERVIEW_SCHEDULER_AGENT",
        agentType: "Interview Scheduler Agent",
        description: "Automate interview coordination and slot booking",
        label: "Interview Scheduling",
    },

    INTERVIEW_AGENT_AUDIO: {
        value: "INTERVIEW_AGENT_AUDIO",
        agentType: "Audio Interview Agent",
        description: "Voice-based interview format",
        label: "Audio Interview",
    },

    INTERVIEW_AGENT_VIDEO: {
        value: "INTERVIEW_AGENT_VIDEO",
        agentType: "Video Interview Agent",
        description: "Face-to-face video format",
        label: "Video Interview",
    },
}
